import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 15m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0","key":"svg-0"}],["path",{"d":"M9 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-1"}],["path",{"d":"M19 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-2"}],["path",{"d":"M14.218 17.975l6.619 -12.174","key":"svg-3"}],["path",{"d":"M6.079 9.756l12.217 -6.631","key":"svg-4"}],["path",{"d":"M9 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-5"}]]

const IconAsset = createReactComponent('outline', 'asset', 'Asset', __iconNode);

export default IconAsset;